import React, { memo } from 'react'
import tw from 'twin.macro'
import { DataRow } from 'src/components/shared/DataRow'
import { SectionCard } from 'src/components/shared/SectionCard'
import { retryActionTypeTitles } from 'src/constants/scheduler/constants'
import type { RetryConfig } from 'src/interfaces/retryConfig'
import { formatDateTime, parseUnixTimestamp } from 'src/utils/grid'

interface Props {
  config: RetryConfig | null
}

const ConfigInfoCardComponent = ({ config }: Props) => {
  // Render nothing rather than placeholder business content when the backend gave us nothing.
  if (!config) {
    return null
  }

  // `createdAt` is unix SECONDS, not an ISO string — pair `parseUnixTimestamp` with
  // `formatDateTime`, the same pairing `webhookDeliveriesGrid.tsx` uses for the same shape.
  const createdAt = parseUnixTimestamp(config.createdAt)

  return (
    <SectionCard title="Config info">
      <div css={tw`flex flex-col gap-2`}>
        <DataRow title="ID" text={config.id} direction="column" />
        <DataRow title="Created at" text={formatDateTime(createdAt)} />
        <DataRow title="Type" text={retryActionTypeTitles[config.type] ?? config.type} />
        <DataRow title="Max attempts" text={String(config.maxAttempts)} />
        <DataRow title="Backoff multiplier" text={String(config.backoffMultiplier)} />
        <DataRow title="Timeout (min)" text={String(config.timeoutMinutes)} />
        <DataRow title="Current attempt" text={String(config.currentAttempt)} />
        <DataRow title="Disabled" text={config.disabled ? 'Yes' : 'No'} />
      </div>
    </SectionCard>
  )
}

export const ConfigInfoCard = memo(ConfigInfoCardComponent)
